module.exports = __webpack_public_path__ + "static/media/why-label.4a0af462.jpg";